import type {SearchCriteriaRaw} from '../../../types';
import {createAttributeHistoryRule} from '../attributeHistoryRule';
import type {AttributeHistoryRule, TSearchTypeAttributeHistory} from '../types';

export type RawAttributeHistorySearchCriteria =
	SearchCriteriaRaw<TSearchTypeAttributeHistory>;

export const rawAttributeHistoryCriteriaToRuleObject = (
	criteria: RawAttributeHistorySearchCriteria,
): AttributeHistoryRule => {
	return createAttributeHistoryRule({
		attributeId: parseInt(criteria.value1) || 0,
		attributeValue: criteria.value2,
	});
};

export default rawAttributeHistoryCriteriaToRuleObject;
